import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { WashroomsFormView } from "./components/WashroomsFormView";
import { WashroomsFormProps, WashroomsFormValues } from "./types";

export const WashroomsForm = ({ defaultValues, onCancel, onSubmit, errorMsg, isEditMode }: WashroomsFormProps) => {
  const form = useForm<WashroomsFormValues>({ defaultValues });

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <WashroomsFormView defaultValues={defaultValues} onCancel={onCancel} error={errorMsg} isEditMode={isEditMode} />
      </form>
    </FormProvider>
  );
};
